if (!window.localStorage) {

    Object.defineProperty(window, 'localStorage', {
        value: memoryStorage()
    });

    function memoryStorage() {

        let storage = {};

        return {
            length: 0,
            key: (index) => '',
            getItem: (key) => storage[key],
            setItem: (key, value) => storage[key] = value,
            removeItem: (key) => delete storage[key],
            clear: () => storage = {}
        };
    }
}

/*
 * WHY DO WE NEED THIS POLYFILL?
 * - On Android devices, when you try to add a new google-app account,
 *   android opens saml-login page of saaspass in an internal browser.
 *   In that browser, localStorage is null.
 * - Some browsers disable localStorage in private browsing mode.
 * - Some users disable it in browser's privacy settings.
 */



// WEBPACK FOOTER //
// ./src/portal/lib/local-storage-polyfill.js